import useTranslation from 'next-translate/useTranslation';
import LoginLayer from '../LoginLayer';
import { getSafeRedirectUrl } from '@/utils/safeRedirect';
import { useRouter } from 'next/router';
import { getZipcode } from '@/utils/common/porder';
import { getStoreInfo } from '@/api/item';
import { setCookieToMemory } from '@/utils/cookie';
import { afterUserLoginToOnboarding } from '@/utils/common/pixel';
import Constants from '@/constants/const';
import { getCookie } from '@/utils/cookie';

import type { LoginFieldType } from '../LoginLayer/types';

type LoginV3Props = {
  redirectUrl?: string;
  showAreaTitle?: boolean;
  defaultActiveLoginMethod?: LoginFieldType;
};

export default function LoginV3(props: LoginV3Props) {
  const { redirectUrl, showAreaTitle = true, defaultActiveLoginMethod } = props;
  const { t, lang } = useTranslation('onboarding');
  const router = useRouter();
  const onThirdLoginSuccess = async (value, res) => {
    const redirectUrl = getSafeRedirectUrl(router.query?.redirect_url as string);
    window.sessionStorage?.removeItem?.('cache-category-list');
    if (lang === Constants.LANGUAGE_EN) {
      let storeInfoResult = await getStoreInfo({ zipcode: getZipcode() });
      if (storeInfoResult?.result) {
        const storeInfo = storeInfoResult?.object || {};
        //有设置store id时, 获取
        setCookieToMemory(Constants.WEEE_STORE, storeInfo.select_store || '');
      }
    }
    await afterUserLoginToOnboarding(res?.next_url, redirectUrl);
    if (getCookie(Constants.REFERRER_ID) && !res?.is_binded) {
      window.location.href = `/${lang}/account/phone-connect?channel_type=phone_verify&redirect_url=${encodeURIComponent(
        redirectUrl
      )}`;
    } else {
      window.location.href = redirectUrl;
    }
  };

  return (
    <div className="flex-1">
      {showAreaTitle && (
        <div className="flex items-center justify-center">
          <h2 className="enki-heading-sm text-primary-1 mt-5">{t('let_get_start')}</h2>
        </div>
      )}
      <LoginLayer
        onSuccess={onThirdLoginSuccess}
        onThirdLoginSuccess={onThirdLoginSuccess}
        defaultActiveLoginMethod={defaultActiveLoginMethod}
      />
    </div>
  );
}
